$(function() {
  function displayOther() {
    const display = $('.experience_industry-other-label').is(':checked') ? 'block' : 'none';
    $('#edit-profile-history-field-history-industry-txt').css('display', display);
  }

  displayOther();
  $('.experience_industry-other-label').on('change', displayOther)
});
